// extracted by mini-css-extract-plugin
export var pagination = "pagination-module--pagination--3J-bq";